import React from 'react';
import {Button } from 'carbon-components-react';
import {Edit16 } from '@carbon/icons-react';

const DescriptionDetails = ({term, definition, editable, onEdit}) => {
    return ( 
        <div className="mb-2">
        <label className="text-xs">{term}                 
</label>
        <p className=''>
          {editable ?<>
            <span className='underline decoration-dotted underline-offset-1 decoration-gray-600 text-gray-600' role="button" onClick={onEdit}>{definition}</span>
          </>: <>{definition}</>}  
        </p>
      </div>
);
}
 
export default DescriptionDetails;